<template>
    <div v-if="author.article != null" class="columns-row">
        <div class="columns_img img-scale-in">
            <a :href="$store.state.hrefPrefix + '/columns/' + author.slug"><img v-if="author.blob != null" style="width: 80px" :src="author.blob.url" alt=""/></a>
        </div>
        <div class="columns_content">
            <h2><a :href="$store.state.hrefPrefix + '/articles/' + author.article.slug">{{ author.article.article_languages[0].pivot.title }}</a></h2>
            <ul>
                <li v-if="author.article.second_author == null">{{ $t('by') }} <b>{{ author.author_languages[0].pivot.name }}</b></li>
                <li v-else>{{ $t('by') }} <b>{{ author.author_languages[0].pivot.name }}</b> & <b>{{ author.article.second_author.author_languages[0].pivot.name }}</b></li>
                <li>{{ formattedCreatedAt}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColumnArticle",
    props: {
        author: {
            type: Object,
            default: null
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.author.article.published_at ?? this.author.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            return date.toLocaleDateString(this.$store.state.language.code === 'ar' ? 'ar-LB' : 'en-US', options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
